import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, Container, Button, Spinner } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router-dom'
import { Context } from '../Statistic'
import { exportAllStatistic } from '../../../../controller/api/__loto__/statistic-by-ticket'
import { exportLotoTicketStatisticToExcel } from '../../../../helpers/excelExport'
import { parseQuery } from '../../../../helper/helper'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);
  const location = useLocation();

  const [isExporting, setIsExporting] = useState(false);

  const _phone = useRef(state.filter.phone);

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        phone: _phone.current
      }
    })
  }, [dispatch])

  const handleExportExcel = async () => {
    const queryObj = parseQuery(location.search)

    if (!queryObj.resultId) {
      alert('Không xác định được kỳ quay số để xuất file')
      return
    }

    let phone = state.filter.phone

    if (phone.indexOf('MB') < 0) {
      phone = phone.replace('0', '+84')
    }

    setIsExporting(true)
    try {
      const response = await exportAllStatistic(cookies.lottmekong, {
        phone: phone,
        resultId: queryObj.resultId
      })

      if (response && response.data) {
        exportLotoTicketStatisticToExcel(response.data, state.filter)
      }
    } catch (error) {
      console.error('Export failed:', error)
      alert('Xuất Excel thất bại. Vui lòng thử lại!')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>THỐNG KÊ</h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
              <Button
                style={{ marginRight: 20 }}
                variant="success"
                type="button"
                disabled={isExporting}
                onClick={handleExportExcel}
              >
                {isExporting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang xuất...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    Xuất Excel
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Col>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Số điện thoại</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)